export default __webpack_public_path__ + "static/media/pic11.c4919a8c.jpg";